import { EMPTY_ARRAY, getAgGridColId, useDefaultColumns, type ColumnDef } from '@talos/kyoko';
import { useMemo } from 'react';
import type { NotificationWithToastInfo } from './useEnrichNotificationsPipe';

const DEFAULT_COLUMNS = [
  'toastInfo.id',
  'toastInfo.timeStamp',
  'toastInfo.appInboxToastType',
  'notification.State',
  'toastInfo.title',
  'toastInfo.description',
  'toastInfo.variant',
  'notification.User',
];

export function useNotificationsColumns() {
  const columnDefinitions = useMemo(
    () =>
      new Map<string, ColumnDef<NotificationWithToastInfo>>(
        (
          [
            {
              field: 'toastInfo.id',
              type: 'text',
              title: 'ID',
              initialWidth: 120,
            },
            {
              field: 'toastInfo.timeStamp',
              type: 'date',
              title: 'Timestamp',
              initialSort: '-',
            },
            {
              field: 'toastInfo.appInboxToastType',
              type: 'text',
              title: 'Type',
            },
            {
              field: 'notification.State',
              type: 'text',
              title: 'State',
            },
            {
              field: 'toastInfo.title',
              type: 'text',
              title: 'Title',
            },
            {
              field: 'toastInfo.description',
              type: 'text',
              title: 'Description',
            },
            {
              field: 'toastInfo.variant',
              type: 'text',
              title: 'Variant',
            },
            {
              field: 'notification.User',
              type: 'text',
              title: 'User',
            },
          ] satisfies ColumnDef<NotificationWithToastInfo>[]
        ).map(c => [getAgGridColId(c), c])
      ),
    []
  );

  return useDefaultColumns(DEFAULT_COLUMNS ?? EMPTY_ARRAY, columnDefinitions);
}
